export default {
  s: '%d sekunda',
  smicro: '%d s',
  smid: '%d sek',

  ss: '%d sekund',
  ssfew: '%d sekundy',
  ssmicro: '%d s',
  ssmid: '%d sek',

  m: '%d minuta',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minut',
  mmfew: '%d minuty',
  mmmicro: '%d m',
  mmmid: '%d min',

  h: '%d godzina',
  hmicro: '%d g',
  hmid: '%d godzina',

  hh: '%d godzin',
  hhfew: '%d godziny',
  hhmicro: '%d g',
  hhmid: '%d godzin',
  hhmidfew: '%d godziny',

  d: '%d dzień',
  dmicro: '%d d',
  dmid: '%d dzień',

  dd: '%d dni',
  ddmicro: '%d d',
  ddmid: '%d dni',
};
